import { Component, OnInit } from '@angular/core';
import {
  AuthService,
  GungModalService,
  NavbarcartComponent,
  NavbarCartService,
  SaveCartModalConfigService
} from 'gung-standard';
import { BaseViewConfigService } from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'cult-navbar-cart',
  templateUrl: './cult-navbar-cart.component.html',
  styleUrls: ['./cult-navbar-cart.component.scss']
})
export class CultNavbarCartComponent extends NavbarcartComponent implements OnInit {
  isReturNoPrice = false;

  constructor(
    protected navbarCartService: NavbarCartService,
    public saveCartModalConfigService: SaveCartModalConfigService,
    protected gungModalService: GungModalService,
    protected authService: AuthService,
    protected baseViewConfigService: BaseViewConfigService
  ) {
    super(navbarCartService, saveCartModalConfigService, gungModalService, baseViewConfigService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
  }
}
